import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApiMiddlewarePayload } from '@ocean/api'
import { FilterKeyType } from '@ocean/types/dist/filter'
import { FilterUtils } from '@ocean/utils'
import { ApiAction } from 'api'
import { createApiAction } from 'api'
import { userLoggedOut } from 'core/session/slices/session'
import { VirtualEventStatus } from 'modules/virtualClassrooms/common/types/manager'
import { getVirtualEvents } from 'modules/virtualClassrooms/manager/EventList/api/eventListService'
import {
  VirtualEvent,
  EventListFilterItem,
  EventListFilterItems,
} from 'modules/virtualClassrooms/manager/EventList/types'
import { EventListState, ApiEventListResponse } from './types'

const initialState: EventListState = {
  eventListData: {},
  filters: {
    search: { keyType: FilterKeyType.String, searchKey: 'title' },
    categoryId: { keyType: FilterKeyType.String },
    eventStatus: { keyType: FilterKeyType.Number, value: VirtualEventStatus.Published },
  },
}

const eventListSlice = createSlice({
  name: 'virtualClassroomManagerEventList',
  initialState,
  reducers: {
    eventListDataLoaded(state, action: PayloadAction<ApiMiddlewarePayload<ApiEventListResponse>>) {
      state.eventListData = action.payload
    },
    setFilters(state, action: PayloadAction<EventListFilterItem>) {
      const filter = state.filters[action.payload.name]
      if (filter) filter.value = action.payload.value
    },
  },
  extraReducers: builder => {
    builder.addCase(userLoggedOut, () => {
      return initialState
    })
  },
})

const { eventListDataLoaded } = eventListSlice.actions
export const { setFilters } = eventListSlice.actions
export default eventListSlice.reducer

export const getFilteredEvents = createSelector(
  (eventList: VirtualEvent[] = [], filters: EventListFilterItems) => ({ eventList, filters }),
  ({ eventList, filters }) => FilterUtils.filterData(filters, eventList)
)

export const loadEventListData = (): ApiAction => {
  return createApiAction({
    apiCalls: {
      list: getVirtualEvents,
    },
    payloadAction: eventListDataLoaded,
  })
}
